import React from 'react';
import { Card } from 'react-bootstrap';

const Commissions: React.FC = () => {
  return (
    <div className="commissions-page" style={{ padding: '20px' }}>
      <h2>Справочники</h2>
      <h3 className="mb-4">Справочник комиссий</h3>
      <Card>
        <Card.Body>
          <p className="text-muted mb-0">Раздел в разработке.</p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Commissions;
